import Select from 'react-select';

const customStyles = {
  control: (provided, state) => ({
    ...provided,
    border: state.isFocused ? '1px solid #324234' : '1px solid #cccccc',
    boxShadow: 'none',
    '&:hover': {
      border: '1px solid #324234',
      boxShadow: 'none',
    },
    cursor: 'default',
  }),
};

export default function SingleSelectDropdown(props) {
  const handleChange = (selectedOption) => {
    if (selectedOption) {
      const newValue = [selectedOption.value];
      if (props.dataIndex !== undefined) {
        props.setItems(newValue, props.dataIndex);
      } else {
        props.setItems(newValue);
      }
    } else {
      // Handle case when an existing option is cleared (selectedOption is null or undefined)
      // For example, reset the value or do nothing based on your requirements.
    }
  };

  const selectedValue = props.items && props.items[0] ? { value: props.items[0], label: props.items[0] } : null;

  return (
    <Select
      isMulti={false} // Set to true to make it single-select with the ability to create new options
      placeholder={props.placeholder}
      onChange={handleChange}
      options={props.options}
      styles={customStyles}
      value={selectedValue}
      closeMenuOnSelect={true} // Set to true to allow closing the menu after selecting an option
    />
  );
}
